// extracted by mini-css-extract-plugin
export var fileUpload = "_fz-1";
export var modalButton = "_fz-0";